import state from './state'
import actions from './actions'
import modules from './modules'
import getters from './getters'
import mutations from './mutations'

export default {
    namespaced: true,
    state,
    actions,
    modules,
    getters,
    mutations
}
